import { useState, useCallback, useEffect } from 'react';

var SIBLING_SIZE = 2;
var BOUNDARY_SIZE = 2;
var usePaginated = function usePaginated(_ref) {
  var totalPage = _ref.totalPage,
      currentPage = _ref.currentPage,
      _ref$siblingsSize = _ref.siblingsSize,
      siblingsSize = _ref$siblingsSize === void 0 ? SIBLING_SIZE : _ref$siblingsSize,
      _ref$boundarySize = _ref.boundarySize,
      boundarySize = _ref$boundarySize === void 0 ? BOUNDARY_SIZE : _ref$boundarySize;
  var totalPageItems = [].concat(Array(totalPage)).fill(1).map(function (_, i) {
    return i + 1;
  });

  var _useState = useState([]),
      pages = _useState[0],
      updatePages = _useState[1];

  var displayPageItemsSize = siblingsSize * 2 + 1;
  var isReachedToFirst = useCallback(function () {
    return currentPage <= siblingsSize;
  }, [currentPage, siblingsSize]);
  var isReachedToLast = useCallback(function () {
    return currentPage + siblingsSize >= totalPage;
  }, [currentPage, siblingsSize, totalPage]);
  var setPages = useCallback(function () {
    if (isReachedToFirst()) {
      return updatePages(totalPageItems.slice(0, displayPageItemsSize));
    }

    if (isReachedToLast()) {
      return updatePages(totalPageItems.slice(-displayPageItemsSize));
    }

    return updatePages(totalPageItems.slice(currentPage - siblingsSize - 1, currentPage + siblingsSize)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReachedToFirst, isReachedToLast, currentPage, siblingsSize, displayPageItemsSize]);
  var hasPrev = useCallback(function () {
    return currentPage > 1;
  }, [currentPage]);
  var hasNext = useCallback(function () {
    return totalPage > currentPage;
  }, [totalPage, currentPage]);
  var prevAllPages = totalPageItems.slice(0, pages[0] - 1);
  var nextAllPages = totalPageItems.slice(pages[pages.length - 1], totalPageItems[totalPageItems.length]);
  var getFirstBoundary = useCallback(function () {
    if (isReachedToFirst()) {
      return [];
    }

    if (prevAllPages.length < 1) {
      return [];
    }

    var boundary = totalPageItems.slice(0, boundarySize).filter(function (p) {
      return !pages.includes(p);
    });
    return boundary;
  }, [boundarySize, isReachedToFirst, pages, prevAllPages.length, totalPageItems]);
  var getLastBoundary = useCallback(function () {
    if (isReachedToLast()) {
      return [];
    }

    if (nextAllPages.length < 1) {
      return [];
    }

    var boundary = totalPageItems.slice(totalPageItems.length - boundarySize, totalPageItems.length).filter(function (p) {
      return !pages.includes(p);
    });
    return boundary;
  }, [boundarySize, isReachedToLast, nextAllPages.length, pages, totalPageItems]);
  var isPrevTruncated = prevAllPages.filter(function (p) {
    return !getFirstBoundary().includes(p) && !pages.includes(p);
  }).length > 0;
  var isNextTruncated = nextAllPages.filter(function (p) {
    return !getLastBoundary().includes(p) && !pages.includes(p);
  }).length > 0;
  useEffect(function () {
    setPages();
  }, [totalPage, currentPage, setPages]);
  return {
    pages: pages,
    hasPrev: hasPrev,
    hasNext: hasNext,
    getFirstBoundary: getFirstBoundary,
    getLastBoundary: getLastBoundary,
    isPrevTruncated: isPrevTruncated,
    isNextTruncated: isNextTruncated,
    totalPage: totalPage,
    currentPage: currentPage
  };
};

var Paginated = function Paginated(_ref) {
  var children = _ref.children,
      totalPage = _ref.totalPage,
      currentPage = _ref.currentPage,
      siblingsSize = _ref.siblingsSize,
      boundarySize = _ref.boundarySize;
  var paginated = usePaginated({
    totalPage: totalPage,
    currentPage: currentPage,
    siblingsSize: siblingsSize,
    boundarySize: boundarySize
  });
  return children(paginated);
};

export { Paginated, usePaginated };
//# sourceMappingURL=paginated.esm.js.map
